import { type CSSProperties, type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useOpenableControls } from '../../../generic-hooks'
import { IconMessageRight } from '../../../icons'
import { PersonalAdviceDialog } from '../../../personal-advice'
import { useProductPageContext } from '../productPageContext'

export const ProductPagePersonalAdviceButton: FC = () => {
  const dialogControls = useOpenableControls()
  const { product } = useProductPageContext()

  return (
    <>
      <Button
        onClick={dialogControls.handleOpen}
        size="medium"
        startIcon={<IconMessageRight />}
        // eslint-disable-next-line react/forbid-component-props -- icon should have text color in this case, UX requirement
        style={{ '--button-icon-color': 'inherit' } as CSSProperties}
        type="button"
        variant="text"
      >
        <FormattedMessage id="buyBox.link.label.personalAdvice" />
      </Button>
      <PersonalAdviceDialog dialogControls={dialogControls} product={product} />
    </>
  )
}
